import Base from './base'
import urls from 'config/urls'

class Shop extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.shop.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.shop.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.shop.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.shop.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.shop.delete,
      data: opts
    })
  }

  findArea (opts) {
    return this.httpGet({
      url: urls.shop.findArea,
      data: opts
    })
  }

  findRegion (opts) {
    return this.httpGet({
      url: urls.shop.findRegion,
      data: opts
    })
  }
}

export default new Shop



// WEBPACK FOOTER //
// ./src/models/shop.js